import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RecruitmentStatusType } from "../../../configs/constants/RecruitmentStatusType";
import Consultant from "../../../models/Consultant";
import { KeyValue } from "../../../models/KeyValue";
import { useUpdateCandidateRecruitmentDetails } from "../../../networking/candidate.hooks";
import { enumToKeyValueArray } from "../../../utils/object.utils";
import AppText from "../../Core/AppText/AppText";
import Button from "../../Core/Button/Button";
import Dropdown from "../../Core/Dropdown/Dropdown";
import Modal from "../../Core/Modal/Modal";

interface RecruitmentStatusModalProps {
	hideModal: Function;
	candidate?: Consultant;
}

const RecruitmentStatusModal: React.FC<RecruitmentStatusModalProps> = ({
	hideModal,
	candidate,
}) => {
	const { t } = useTranslation();

	const { mutate: updateRecruitment } = useUpdateCandidateRecruitmentDetails();

	const statusOptions = enumToKeyValueArray(RecruitmentStatusType);

	const [status, setStatus] = useState<RecruitmentStatusType>(
		candidate?.profile.recruitment?.status || RecruitmentStatusType.IN_REVIEW
	);

	const createAbsence = async () => {
		hideModal();
		if (candidate?.id && candidate?.profile.recruitment?.status !== status)
			await updateRecruitment({ userId: candidate.id, update: { status } });
	};

	return (
		<Modal>
			<AppText size="xm" weight="bold">
				{t("CHANGE_STATUS_TITLE")}
			</AppText>
			<AppText margin="1.5rem 0 2rem 0" textAlign="center">
				{t("CHANGE_STATUS_TEXT")}
			</AppText>
			<Dropdown<KeyValue, RecruitmentStatusType>
				onChange={setStatus}
				getValue={(o) => o.key as RecruitmentStatusType}
				value={statusOptions.find(({ key }) => key === status)}
				options={statusOptions}
				getOptionLabel={(option: KeyValue) => t(option.value as any)}
			/>
			<Button onClick={() => createAbsence()} width="150px">
				{t("UPDATE_RECRUITMENT_STATUS")}
			</Button>
			<Button
				onClick={() => hideModal()}
				width="150px"
				margin="1rem 0 0 0"
				textColor="black"
				backgroundColor="buttonGray"
			>
				{t("CANCEL_RECRUITMENT_STATUS_UPDATE")}
			</Button>
		</Modal>
	);
};

export default RecruitmentStatusModal;
